import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css']
})
export class PasswordComponent implements OnInit {
  @Input() label = '';
  @Input() labelPos = 'before';
  @Input() placeholder = '';
  @Input() name = 'password';
  @Input() inputclass = '';
  @Input() id = 'password';
  public password = '';

  public inputtype = 'password';

  constructor() { }

  ngOnInit() {
  }

  show() {
    this.inputtype = 'text';
  }
  hide() {
    this.inputtype = 'password';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/password/password.component.ts